import { cashCollectionAppServiceApi } from "../../../app/cashCollection/cashCollectionAppServiceApi";
import { BASE_API_CASH_COLLECTION } from "../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../types";
import {
  GetAllCollectionPointDataParamsType,
  GetAllCollectionPointDataType,
  GetAllSRDataParamsType,
  GetAllSRDataType,
  GetAllTransactionsDataParamsType,
  GetAllTransactionsDataType,
  GetCashCollectionDataType,
  GetCashCollectionParamsType,
  GetCashCollectionState1DataParamsType,
  GetCashCollectionState1DataType,
  GetCashCollectionState2DataParamsType,
  GetCashCollectionState2DataType,
  GetCashCollectionState3DataParamsType,
  GetCashCollectionState3DataType,
  GetCashCollectionState4DataParamsType,
  GetCashCollectionState4DataType,
  GetSingleCollectionPointDataType,
  GetSingleSRDataType,
  GetTransactionsSummaryDataParamsType,
  GetTransactionsSummaryDataType,
  GetTransitionDetailsDataType,
} from "../../../types/cashCollection/cashCollectionSetup";

export const cashCollectionSetupApi =
  cashCollectionAppServiceApi.injectEndpoints({
    endpoints: (builder) => ({
      // SR Setup
      createSR: builder.mutation({
        query: (data) => ({
          url: BASE_API_CASH_COLLECTION.createSR,
          method: "POST",
          body: data,
        }),
        invalidatesTags: (result) => {
          if (result) return ["GetSR"];
          return [];
        },
      }),

      updateSR: builder.mutation({
        query: ({ id, data }) => ({
          url: `${BASE_API_CASH_COLLECTION.updateSR}/${id}`,
          method: "PATCH",
          body: data,
        }),
        invalidatesTags: (result) => {
          if (result) return ["GetSR", "GetSRSingle"];
          return [];
        },
      }),

      updateSRStatus: builder.mutation({
        query: ({ id, data }) => ({
          url: `${BASE_API_CASH_COLLECTION.updateSR}/${id}/status`,
          method: "PATCH",
          body: data,
        }),
        invalidatesTags: (result) => {
          if (result) return ["GetSR", "GetSRSingle"];
          return [];
        },
      }),

      getAllSR: builder.query<
        GetAllSRDataType,
        GetQueryArgsType<GetAllSRDataParamsType>
      >({
        query: (queryArgs) => ({
          url: BASE_API_CASH_COLLECTION.getAllSR,
          params: queryArgs.params,
        }),
        providesTags: ["GetSR"],
      }),

      getSingleSR: builder.query<GetSingleSRDataType, any>({
        query: (id) => ({
          url: `${BASE_API_CASH_COLLECTION.getSingleSR}/${id}`,
        }),
        providesTags: (_, __, id) => [{ type: "GetSRSingle", id }],
      }),

      getCashCollection: builder.query<
        GetCashCollectionDataType,
        GetQueryArgsType<GetCashCollectionParamsType>
      >({
        query: (queryArgs) => ({
          url: BASE_API_CASH_COLLECTION.getCashCollection,
          params: queryArgs.params,
        }),
        providesTags: ["GetCashCollection"],
      }),

      // Transaction Setup

      getTransactions: builder.query<
        GetAllTransactionsDataType,
        GetQueryArgsType<GetAllTransactionsDataParamsType>
      >({
        query: (queryArgs) => ({
          url: BASE_API_CASH_COLLECTION.getTransactions,
          params: queryArgs.params,
        }),
        providesTags: ["GetTransactions"],
      }),

      getTransactionsSummary: builder.query<
        GetTransactionsSummaryDataType,
        GetQueryArgsType<GetTransactionsSummaryDataParamsType>
      >({
        query: (queryArgs) => ({
          url: BASE_API_CASH_COLLECTION.getTransactionsSummary,
          params: queryArgs.params,
        }),
        providesTags: ["GetTransactionsSummary"],
      }),

      getBankTransactions: builder.query<
        GetTransactionsSummaryDataType,
        GetQueryArgsType<GetTransactionsSummaryDataParamsType>
      >({
        query: (queryArgs) => ({
          url: BASE_API_CASH_COLLECTION.getBankTransactions,
          params: queryArgs.params,
        }),
        providesTags: ["GetBankTransactions"],
      }),

      getTransitionDetails: builder.query<GetTransitionDetailsDataType, any>({
        query: ({ srId, id, dateFrom, dateTo }) => ({
          url: `${BASE_API_CASH_COLLECTION.getTransitionDetails}/${srId}/${id}`,
          params: {
            dateFrom,
            dateTo,
          },
        }),
        providesTags: (_, __, id) => [{ type: "GetTransitionDetails", id }],
      }),

      // Collection Point Setup

      createCollectionPoint: builder.mutation({
        query: (data) => ({
          url: BASE_API_CASH_COLLECTION.createCollectionPoint,
          method: "POST",
          body: data,
        }),
        invalidatesTags: (result) => {
          if (result) return ["GetAllCollectionPoint"];
          return [];
        },
      }),

      updateCollectionPoint: builder.mutation({
        query: ({ id, data }) => ({
          url: `${BASE_API_CASH_COLLECTION.updateCollectionPoint}/${id}`,
          method: "PATCH",
          body: data,
        }),
        invalidatesTags: (result) => {
          if (result) return ["GetAllCollectionPoint", "GetAllCollectionPoint"];
          return [];
        },
      }),

      updateCollectionPointStatus: builder.mutation({
        query: ({ id, data }) => ({
          url: `${BASE_API_CASH_COLLECTION.updateCollectionPoint}/${id}/status`,
          method: "PATCH",
          body: data,
        }),
        invalidatesTags: (result) => {
          if (result) return ["GetAllCollectionPoint", "GetAllCollectionPoint"];
          return [];
        },
      }),
      updateUserForBankId: builder.mutation({
        query: ({ id, data }) => ({
          url: `${BASE_API_CASH_COLLECTION.updateUserForBankId}/${id}`,
          method: "PATCH",
          body: data,
        }),
        invalidatesTags: (result) => {
          if (result) return ["GetBankTransactions"];
          return [];
        },
      }),

      getAllCollectionPoint: builder.query<
        GetAllCollectionPointDataType,
        GetQueryArgsType<GetAllCollectionPointDataParamsType>
      >({
        query: (queryArgs) => ({
          url: BASE_API_CASH_COLLECTION.getAllCollectionPoint,
          params: queryArgs.params,
        }),
        providesTags: ["GetAllCollectionPoint"],
      }),

      getSingleCollectionPoint: builder.query<
        GetSingleCollectionPointDataType,
        any
      >({
        query: (id) => ({
          url: `${BASE_API_CASH_COLLECTION.getSingleCollectionPoint}/${id}`,
        }),
        providesTags: (_, __, id) => [{ type: "GetSingleCollectionPoint", id }],
      }),

      // Dashboard Setup

      getCashCollectionState1: builder.query<
        GetCashCollectionState1DataType,
        GetQueryArgsType<GetCashCollectionState1DataParamsType>
      >({
        query: (queryArgs) => ({
          url: BASE_API_CASH_COLLECTION.getCashCollectionState1,
          params: queryArgs.params,
        }),
        providesTags: ["GetCashCollectionState1"],
      }),

      getCashCollectionState2: builder.query<
        GetCashCollectionState2DataType,
        GetQueryArgsType<GetCashCollectionState2DataParamsType>
      >({
        query: (queryArgs) => ({
          url: BASE_API_CASH_COLLECTION.getCashCollectionState2,
          params: queryArgs.params,
        }),
        providesTags: ["GetCashCollectionState2"],
      }),

      getCashCollectionState3: builder.query<
        GetCashCollectionState3DataType,
        GetQueryArgsType<GetCashCollectionState3DataParamsType>
      >({
        query: (queryArgs) => ({
          url: BASE_API_CASH_COLLECTION.getCashCollectionState3,
          params: queryArgs.params,
        }),
        providesTags: ["GetCashCollectionState3"],
      }),

      getCashCollectionState4: builder.query<
        GetCashCollectionState4DataType,
        GetQueryArgsType<GetCashCollectionState4DataParamsType>
      >({
        query: (queryArgs) => ({
          url: BASE_API_CASH_COLLECTION.getCashCollectionState4,
          params: queryArgs.params,
        }),
        providesTags: ["GetCashCollectionState4"],
      }),

      statsByUsers: builder.mutation({
        query: (data) => ({
          url: BASE_API_CASH_COLLECTION.statsByUsers,
          method: "POST",
          body: data,
        }),
        invalidatesTags: (result) => {
          if (result) return ["GetAllCollectionPoint"];
          return [];
        },
      }),
    }),
  });

export const {
  useCreateSRMutation,
  useUpdateSRMutation,
  useGetAllSRQuery,
  useGetSingleSRQuery,
  useGetTransactionsQuery,
  useGetTransactionsSummaryQuery,
  useGetTransitionDetailsQuery,
  useCreateCollectionPointMutation,
  useUpdateCollectionPointMutation,
  useGetAllCollectionPointQuery,
  useGetSingleCollectionPointQuery,
  useUpdateSRStatusMutation,
  useUpdateCollectionPointStatusMutation,
  useGetCashCollectionState1Query,
  useGetCashCollectionState2Query,
  useGetCashCollectionState3Query,
  useGetCashCollectionState4Query,
  useGetBankTransactionsQuery,
  useUpdateUserForBankIdMutation,
  useStatsByUsersMutation,
  useGetCashCollectionQuery,
} = cashCollectionSetupApi;
